<template>
    <div>
        <vx-card class="w-full">
            <div class="vx-row">
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-6">
                    <h4 v-if="channel.name.length > 0" class="mb-3">{{channel.name}} on <router-link :to="'/worker/' + channel.worker_id">{{(channel.worker_id > 0) ? channel.worker_name : "cluster " + channel.cluster_id}}</router-link></h4>
                    <div id="dataDiv"  class="vs-con-loading__container">
                        <img class="mb-6" v-if="channel.image_id.length > 0" style="width: 50%; max-width: 150px;" :src="'/api/management/v1/channel_logo/' + channel.image_id" :alt="channel.name">
                        <table class="simple-table">
                            <tr>
                                <td class="font-semibold">Channel name:</td>
                                <td>{{ channel.channel_name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Name:</td>
                                <td>{{ channel.name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Serialized name:</td>
                                <td>{{ channel.serialized_name }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Upstream type:</td>
                                <td>{{ upstreamTypeToString(channel.upstream_type) }}</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Memory limit:</td>
                                <td>{{ channel.memory_limit }}MB</td>
                            </tr>

                            <tr v-if="channel.gpu.length > 0">
                                <td class="font-semibold">GPU:</td>
                                <td>{{ (gpusMap[channel.gpu]) ? gpusMap[channel.gpu] : "Unknown" }}</td>
                            </tr>

                            <tr v-else-if="possibleGPUs.length > 0">
                                <td class="font-semibold">GPU:</td>
                                <td>All</td>
                            </tr>

                            <tr>
                                <td class="font-semibold">Status:</td>
                                <td>
                                    <vs-chip v-if="channel.status === 1 && !channel.disabled" color="success">Online</vs-chip>
                                    <vs-chip v-else-if="channel.disabled" color="warning">Disabled</vs-chip>
                                    <vs-chip v-else color="danger">Offline</vs-chip>
                                </td>
                            </tr>

                            <tr v-if="channel.status !== 0 && !channel.disabled">
                                <td class="font-semibold">Output type:</td>
                                <td>
                                    <vs-chip v-if="channel.output_type === 1" color="#3498db">UDP</vs-chip>
                                    <vs-chip v-else-if="channel.output_type === 2" color="#2ecc71" style="cursor:pointer;" @click.native="getChannelLink()">HLS</vs-chip>
                                    <vs-chip v-else-if="channel.output_type === 3" color="#9b59b6" style="cursor:pointer;" @click.native="getChannelLink()">MPEGTS</vs-chip>
                                    <vs-chip v-else color="warning">Unknown</vs-chip>
                                </td>
                            </tr>

                        </table>
                        <vs-divider v-if="$store.state.windowWidth < 1200"/>
                    </div>
                </div>

                <div class="vx-col xl:w-2/3 lg:w-1/2 w-full">
                    <h4 class="mb-3">Templates</h4>
                    <div id="templateDiv" class="vs-con-loading__container mb-6">
                        <div class="vx-row">
                            <div class="vx-col xl:w-1/3 xl:mb-0 w-full mb-6">
                                <h5 class="mb-2">Input</h5>
                                <div v-if="templatesLoaded">
                                    <b>Name</b>: {{inTemplate.name}}
                                    <p :key="value.key + index" v-for="(value, index) in inTemplateParams"><b>{{value.name}}:</b> {{value.value}}</p>
                                </div>
                            </div>
                            <div class="vx-col xl:w-1/3 xl:mb-0 w-full mb-6">
                                <h5>Work</h5>
                                <div v-if="templatesLoaded">
                                    <b>Name</b>: {{workTemplate.name}}
                                    <p :key="value.key + index" v-for="(value, index) in workTemplateParams"><b>{{value.name}}:</b> {{value.value}}</p>
                                </div>
                            </div>
                            <div class="vx-col xl:w-1/3 xl:mb-0 w-full mb-6">
                                <h5>Output</h5>
                                <div v-if="templatesLoaded">
                                    <b>Name</b>: {{outTemplate.name}}
                                    <p :key="value.key + index" v-for="(value, index) in outTemplateParams"><b>{{value.name}}:</b> {{value.value}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <vs-divider/>
                    <restarts-table :worker-channel-id="Number($route.params.id)"/>
                </div>
            </div>
            <vs-divider/>

            <vs-button style="float: left" icon-pack="feather" icon="icon-edit" color="warning" class="mt-3 mr-1" @click="$router.push('/worker_channel/' + $route.params.id + '/edit')">Edit</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-arrow-right" color="primary" class="mt-3 mr-1 vs-con-loading__container" id="movePromptButton" @click="openMovePrompt">Move</vs-button>

            <vs-button style="float: right" icon-pack="feather" icon="icon-play" color="success" class="mt-3 mr-1" v-if="channel.disabled" @click="startChannel"/>
            <div style="float: right">
                <vs-button style="float: left" icon-pack="feather" icon="icon-refresh-cw" color="warning" class="mt-3 mr-1" v-if="!channel.disabled" @click="restartChannel"/>
                <vs-button style="float: left" icon-pack="feather" icon="icon-square" color="danger" class="mt-3 mr-1" v-if="!channel.disabled" @click="disableChannel"/>
            </div>

            <div style="clear: both"></div>
        </vx-card>

        <div class="w-full mb-6" v-if="channel.worker_id > 0">
            <multicast-proxy-table :worker-id="channel.worker_id" :channel-id="Number($route.params.id)"/>
        </div>

        <div class="vx-row mt-6" v-if="channel.name.length > 0 && !channel.disabled && channel.status === 1">

            <template>
                <h4 class="mb-3">Current session - </h4>
                <uptime-counter :start-time="channel.last_session_start_time"></uptime-counter>
            </template>

            <div class="vx-col w-full" v-if="channel.last_session_shaka_usage < 3">
                <vx-card title="Command">
                    <p>{{channel.last_session_command}}</p>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3" v-if="channel.last_session_shaka_usage > 0">
                <vx-card title="Shaka Command">
                    <p>{{channel.last_session_shaka_command}}</p>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsFPSDiv" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[metricsFPSRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="metricsFPSRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsFPSRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsFPSRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsFPSRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsFPSRange = 0">Full chart</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="refreshFPSMetrics()"></feather-icon>
                    </template>

                    <vue-apex-charts type="line" height="350" :options="getChartOptions('FPS', '#7367F0')" :series="metricsFPS"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsStreamDifferenceDiv" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[metricsStreamDifferenceRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="metricsStreamDifferenceRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsStreamDifferenceRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsStreamDifferenceRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsStreamDifferenceRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsStreamDifferenceRange = 0">Full chart</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="refreshStreamDifferenceMetrics()"></feather-icon>
                    </template>

                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Stream time difference', '#FF9F43')" :series="metricsStreamDifference"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsBitrateDiv" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[metricsBitrateRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="metricsBitrateRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsBitrateRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsBitrateRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsBitrateRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsBitrateRange = 0">Full chart</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="refreshBitrateMetrics()"></feather-icon>
                    </template>

                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Bitrate', '#28C76F')" :series="metricsBitrate"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsSpeedDiv" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[metricsSpeedRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="metricsSpeedRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsSpeedRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsSpeedRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsSpeedRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="metricsSpeedRange = 0">Full chart</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="refreshSpeedMetrics()"></feather-icon>
                    </template>

                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Speed', '#EA5455')" :series="metricsSpeed"/>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3">
                <vx-card title="Logs" id="logsDiv" class="vs-con-loading__container">
                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{logTimes[selectedLogDuration]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="selectedLogDuration = -1">Last 25 lines</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 0">Full logs</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadCurrentSessionLogs()"></feather-icon>
                    </template>

                    <p id="logContainer" style="white-space: pre-wrap; font-family: monospace; max-height: 550px; overflow: scroll">{{logs}}</p>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3">
                <vx-card v-if="channel.name.length > 0" title="Checker">
                    <table class="simple-table">
                        <tr>
                            <td class="font-semibold">Enabled:</td>
                            <td v-if="channel.checker_enabled"><vs-chip color="success">Yes</vs-chip></td>
                            <td v-else><vs-chip color="danger">No</vs-chip></td>
                        </tr>
                        <tr v-if="channel.checker_enabled">
                            <td class="font-semibold">Check HLS files:</td>
                            <td v-if="channel.last_session_check_files"><vs-chip color="success">Yes</vs-chip></td>
                            <td v-else><vs-chip color="danger">No</vs-chip></td>
                        </tr>
                        <tr v-if="channel.checker_enabled">
                            <td class="font-semibold">Command:</td>
                            <td>{{ channel.last_session_checker_command }}</td>
                        </tr>

                    </table>

                </vx-card>
            </div>

        </div>

        <div class="vx-row  mt-6">
            <div class="vx-col w-full mt-3">
                <sessions-table :worker-channel-id="Number($route.params.id)"/>
            </div>
        </div>

        <h4 class="mb-3 mt-6">Sources</h4>
        <sources-table ref="sourcesTable" :sources-u-r-l="'/api/management/v1/worker_channel/' + this.$route.params.id + '/sources'" :marked-source="(channel.name.length > 0 && !channel.disabled && channel.status === 1) ? channel.last_session_source_id : 0"/>

        <vs-popup title="Move channel" :active.sync="movePromptOpen">

            <div id="moveChannelDiv" class="vs-con-loading__container" >

                <vx-card card-background="warning" content-color="#fff" v-if="moveTargetOptions.warning.length > 0">
                    <div class="vx-row">
                        <div class="vx-col w-1/12">
                            <feather-icon style="color:#fff" icon="AlertTriangleIcon" color="#fff" class="mt-2"/>
                        </div>
                        <div class="vx-col w-11/12">
                            <p> {{moveTargetOptions.warning}} </p>
                        </div>
                    </div>

                </vx-card>

                <vx-card card-background="warning" content-color="#fff" v-if="moveTarget.warning.length > 0">
                    <div class="vx-row">
                        <div class="vx-col w-1/12">
                            <feather-icon style="color:#fff" icon="AlertTriangleIcon" color="#fff"/>
                        </div>
                        <div class="vx-col w-11/12">
                            <p> {{moveTarget.warning}} </p>
                        </div>
                    </div>

                </vx-card>

                <p class="mt-6">Target worker</p>
                <vs-select autocomplete class="w-full" v-model="moveTarget">
                    <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item,index) in moveTargetOptions.targets" />
                </vs-select>
                <vs-divider/>
                <vs-button icon-pack="feather" icon="icon-arrow-right" color="success" class="mt-3 mr-1" @click="moveChannel">Move</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import Templates from '../Templates/Templates'
    import VueApexCharts from 'vue-apexcharts'
    import UptimeCounter from './UptimeCounter'
    import MulticastProxyTable from '../MulticastProxy/MulticastProxyTable'
    import SessionsTable from './SessionsTable'
    import SourcesTable from '../Sources/SourcesTable'
    import RestartsTable from './RestartsTable'

    export default {
        components: {
            RestartsTable,
            SourcesTable,
            SessionsTable,
            UptimeCounter,
            Templates,
            VueApexCharts,
            MulticastProxyTable
        },
        data() {
            return {

                channel: {
                    name: '',
                    image_id: '',
                    worker_id: 0,
                    cluster_id: 0,
                    gpu: '',
                    disabled: false,
                    in_template: { id: 0 },
                    work_template: { id: 0 },
                    out_template: { id: 0 }
                },

                templatesLoaded: false,
                inTemplate: { id: 0, name: 'Default' },
                workTemplate: { id: 0, name: 'Default' },
                outTemplate: { id: 0, name: 'Default' },

                updateDataTimer: null,

                selectedLogDuration: -1,

                logs: '',
                logTimes: {
                    '-1': 'Last 25 lines',
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    0: 'Full logs'
                },

                metricsFPS: [],
                metricsBitrate: [],
                metricsSpeed: [],
                metricsStreamDifference: [],

                metricsFPSRange: 1,
                metricsBitrateRange: 1,
                metricsSpeedRange: 1,
                metricsStreamDifferenceRange: 1,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    0: 'Full chart'
                },

                moveTargetOptions: {
                    targets: [],
                    warning: ''
                },
                movePromptOpen: false,
                moveTarget: {
                    worker_id: 0,
                    warning: ''
                },

                possibleGPUs: []

            }
        },
        methods: {
            moveChannel() {
                this.$vs.loading({
                    container: '#moveChannelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.put('/api/management/v1/worker_channel/' + this.$route.params.id + '/move/' + this.moveTarget.worker_id)
                loadPromise.then(function() {
                    thisIns.movePromptOpen = false
                    thisIns.$nextTick(function() {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#moveChannelDiv > .con-vs-loading')
                })
            },
            openMovePrompt() {
                this.$vs.loading({
                    container: '#movePromptButton',
                    type: 'sound',
                    scale: 0.5
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/move/targets')
                loadPromise.then(function(response) {
                    thisIns.moveTargetOptions = response.data
                    thisIns.$nextTick(function() {
                        thisIns.movePromptOpen = true
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#movePromptButton > .con-vs-loading')
                })
            },
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.channel = response.data

                    thisIns.$vs.loading({
                        container: '#templateDiv',
                        type: 'corners',
                        scale: 0.7
                    })

                    const templatePromises = []

                    if (thisIns.channel.in_template.id > 0) {
                        const inTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.channel.in_template.id)
                        inTemplatePromise.then(function(response) {
                            thisIns.inTemplate = response.data
                        }).catch(function(error) {
                            thisIns.$printError(error.response.data)
                        })

                        templatePromises.push(inTemplatePromise)
                    }

                    if (thisIns.channel.work_template.id > 0) {
                        const workTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.channel.work_template.id)
                        workTemplatePromise.then(function(response) {
                            thisIns.workTemplate = response.data
                        }).catch(function(error) {
                            thisIns.$printError(error.response.data)
                        })

                        templatePromises.push(workTemplatePromise)
                    }

                    if (thisIns.channel.out_template.id > 0) {
                        const outTemplatePromise = thisIns.$http.get('/api/management/v1/template/' + thisIns.channel.out_template.id)
                        outTemplatePromise.then(function(response) {
                            thisIns.outTemplate = response.data
                        }).catch(function(error) {
                            thisIns.$printError(error.response.data)
                        })

                        templatePromises.push(outTemplatePromise)
                    }

                    Promise.all(templatePromises).then(function() {
                        if (!thisIns.updateDataTimer) {
                            thisIns.updateDataTimer = setInterval(() => { thisIns.updateData() }, 3000)
                        }

                        thisIns.templatesLoaded = true
                        thisIns.loadCurrentSessionLogs()
                        thisIns.loadInitialMetrics()
                    }).finally(function() {
                        thisIns.$vs.loading.close('#templateDiv > .con-vs-loading')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const GPUsPromise = thisIns.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/gpu')
                GPUsPromise.then(function(response) {
                    thisIns.possibleGPUs = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, GPUsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            updateData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    if (JSON.stringify(thisIns.channel) !== JSON.stringify(response.data)) {
                        thisIns.channel = response.data
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            loadCurrentSessionLogs() {
                this.$vs.loading({
                    container: '#logsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/logs/' + this.selectedLogDuration)
                loadPromise.then(function(response) {
                    thisIns.logs = response.data
                    const logContainer = thisIns.$el.querySelector('#logContainer')
                    logContainer.scrollTop = logContainer.scrollHeight
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#logsDiv > .con-vs-loading')
                })
            },
            loadInitialMetrics() {
                this.$vs.loading({
                    container: '#metricsFPSDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsBitrateDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsSpeedDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsStreamDifferenceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/metrics/1')
                loadPromise.then(function(response) {
                    thisIns.metricsFPS = [{ name: 'FPS', data: JSON.parse(JSON.stringify(response.data.fps)) }]
                    thisIns.metricsBitrate = [{ name: 'Bitrate', data: response.data.bitrate }]
                    thisIns.metricsSpeed = [{ name: 'Speed', data: response.data.speed }]
                    thisIns.metricsStreamDifference = [{ name: 'Stream time difference', data: response.data.stream_difference }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsFPSDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsBitrateDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsSpeedDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsStreamDifferenceDiv > .con-vs-loading')
                })
            },
            refreshFPSMetrics() {
                this.$vs.loading({
                    container: '#metricsFPSDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/metrics/' + this.metricsFPSRange + '/fps')
                loadPromise.then(function(response) {
                    thisIns.metricsFPS = [{ name: 'FPS', data: JSON.parse(JSON.stringify(response.data)) }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsFPSDiv > .con-vs-loading')
                })
            },
            refreshBitrateMetrics() {
                this.$vs.loading({
                    container: '#metricsBitrateDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/metrics/' + this.metricsBitrateRange + '/bitrate')
                loadPromise.then(function(response) {
                    thisIns.metricsBitrate = [{ name: 'Bitrate', data: JSON.parse(JSON.stringify(response.data)) }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsBitrateDiv > .con-vs-loading')
                })
            },
            refreshSpeedMetrics() {
                this.$vs.loading({
                    container: '#metricsSpeedDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/metrics/' + this.metricsSpeedRange + '/speed')
                loadPromise.then(function(response) {
                    thisIns.metricsSpeed = [{ name: 'Speed', data: JSON.parse(JSON.stringify(response.data)) }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsSpeedDiv > .con-vs-loading')
                })
            },
            refreshStreamDifferenceMetrics() {
                this.$vs.loading({
                    container: '#metricsStreamDifferenceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.channel.last_session_id + '/metrics/' + this.metricsStreamDifferenceRange + '/stream_difference')
                loadPromise.then(function(response) {
                    thisIns.metricsStreamDifference = [{ name: 'Stream time difference', data: JSON.parse(JSON.stringify(response.data)) }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsStreamDifferenceDiv > .con-vs-loading')
                })
            },
            upstreamTypeToString(id) {
                switch (id) {
                case 0: return 'Source'
                case 1: return 'Worker'
                case 2: return 'Cluster'
                case 3: return 'Other'
                }
            },
            getTemplateParams(template, workerData) {
                if (template.id === 0) return []

                const params = {}
                const paramArray = []
                for (let x = 0; x < template.params.length; x++) {
                    params[template.params[x].key] = template.params[x]
                    params[template.params[x].key].value = params[template.params[x].key].default
                }

                for (let x = 0; x < workerData.length; x++) {
                    if (params.hasOwnProperty(workerData[x].key)) {
                        params[workerData[x].key].value = workerData[x].value
                    }
                }

                for (const paramKey in params) {
                    if (params.hasOwnProperty(paramKey)) {
                        paramArray.push(params[paramKey])
                    }
                }

                return paramArray
            },
            startChannel() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.$route.params.id + '/enable')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel started')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            restartChannel() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.$route.params.id + '/restart')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel restarted')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            disableChannel() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.$route.params.id + '/disable', {
                    end_time: this.moment().add(100, 'years')
                })
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel disabled')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            getChartOptions(title, color) {
                return {
                    colors: [color],
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            },
            getChannelLink() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/link')
                reqPromise.then(function(response) {
                    const newLink = response.data
                    thisIns.$copyText(response.data).then(function() {
                        thisIns.$printSuccess('Link copied to clipboard')
                    }, function() {
                        alert(newLink)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        computed: {

            inTemplateParams() {
                return this.getTemplateParams(this.inTemplate, this.channel.in_template.params)
            },
            workTemplateParams() {
                return this.getTemplateParams(this.workTemplate, this.channel.work_template.params)
            },
            outTemplateParams() {
                return this.getTemplateParams(this.outTemplate, this.channel.out_template.params)
            },
            gpusMap() {
                const data = {}
                data[''] = 'All'
                for (let x = 0; x < this.possibleGPUs.length; x++) {
                    data[this.possibleGPUs[x].uuid] = (this.possibleGPUs[x].custom_name.length > 0) ? this.possibleGPUs[x].custom_name : this.possibleGPUs[x].uuid
                }

                return data
            }

        },
        watch: {
            selectedLogDuration() {
                this.loadCurrentSessionLogs()
            },
            metricsFPSRange() {
                this.refreshFPSMetrics()
            },
            metricsSpeedRange() {
                this.refreshSpeedMetrics()
            },
            metricsBitrateRange() {
                this.refreshBitrateMetrics()
            },
            metricsStreamDifferenceRange() {
                this.refreshStreamDifferenceMetrics()
            }
        },
        beforeDestroy() {
            clearInterval(this.updateDataTimer)
        },
        mounted() {
            this.loadData()
        }
    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
